<app-advanced-form
    class="edit-private-info"
    [config]="advancedFormConfig$ | async"
    (events)="onAdvancedFormEvents($event)"
    [mmTestId]="'EDIT_PRIVATE_INFO_PAGE.FORM'"></app-advanced-form>
